module.exports = __webpack_public_path__ + "img/button_list.487d7c48.svg";